o2-search {
  display: block;

  [slot='affix'] {
    .search-clear {
      right: 4.3rem;
    }
  }
}

.o2-search {
  position: relative;

  .search__affix {
    position: absolute;
    bottom: 0.1rem;
    right: 0.1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4.6rem;
    height: 4.6rem;

    &.search__affix--disabled {
      display: none;
    }

    &.search__affix--hidden {
      display: none;
    }
  }

  &.o2-search--readonly {
    .search__affix,
    .search__clear,
    .search-list {
      display: none !important;
    }
  }

  &.o2-search--hidden-suffix {
    o2-input::part(suffix) {
      display: none;
    }
  }

  o2-input::part(input) {
    padding-right: 4.2rem;
  }

  .search__clear {
    position: absolute;
    bottom: 0.1rem;
    right: 4.3rem;
    padding: 0;
    width: 4.2rem;
    height: 4.2rem;
    min-height: 4.2rem;
    border-radius: 0;
    background-color: white;
    border: 0;

    &.search__clear--disabled {
      display: none;
    }

    &.search__clear--autocomplete {
      right: 0.2rem;
    }
  }

  .search-list {
    border: 0.1rem solid var(--border-border-primary, #{$border-primary});
    background: var(--background-main-background-primary, #fff);
    box-shadow: 0 $spacing-3 $spacing-4 ($spacing-2 * -1) rgba(2, 6, 23, 0.15);
    margin-top: 2px;
    margin-bottom: 0;
    border-radius: var(--border-radius, #{$border-radius});
    padding: 0;
    list-style-type: none;
    z-index: 1010;
    transform-origin: center top;
    transition:
      transform 0.2s,
      opacity 0.2s;
    opacity: 0;
    transform: scaleY(0);
    position: absolute;
    width: 100%;
    cursor: pointer;
    overflow: auto;

    .search-list__item {
      min-height: 32px;
      color: var(--o2-black, #{$black});
      padding: $spacing-2 $spacing-4;
      min-height: 3.6rem;
      font-size: 1.4rem;
      opacity: 0;
      transform: translateX(30px);
      transition:
        transform 200ms var(--o2-transition),
        opacity 200ms var(--o2-transition),
        background-color 200ms var(--o2-transition),
        color 200ms var(--o2-transition);
      transition-delay: 0ms;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      span {
        display: block;
        @include text-truncate;
      }

      &.search-list__item--active {
        background: var(--background-main-background-secondary, #{$background-main-secondary});
      }

      &:hover {
        background: var(--background-main-background-hover, #{$background-main-hover});
      }
    }

    &.search-list--open {
      opacity: 1;
      transform: scaleY(1);

      li {
        opacity: 1;
        transform: translateX(0px);
      }
    }
  }
}

o2-search o2-menu {
  --o2-menu-width: 100%;
}
